// packages/escape-html/src/escape-greater.ts
function __unstableEscapeGreaterThan(value) {
  return value.replace(/>/g, "&gt;");
}
export {
  __unstableEscapeGreaterThan as default
};
//# sourceMappingURL=escape-greater.js.map
